<template>
  <Head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">
    <meta name='robots' content='index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'>
    <meta name="dlm-version" content="4.7.70">
    <title v-text="`${title} - Disperindag Maluku Utara`"></title>

    <link rel=canonical
      :href="url">

    <meta property="og:locale" content="id_ID">
    <meta property="og:type" content="article">
    <meta property="og:title"
      :content="`${title} - Disperindag Maluku Utara`">
    <meta property="og:description"
      :content="`${desc.ket}, [&hellip;]`">
    <meta property="og:url"
      :content="url">
    <meta property="og:site_name" :content="host">
    <!-- <meta property="og:image" content="">
    <meta property="og:image:width" content="1024">
    <meta property="og:image:height" content="581">
    <meta property="og:image:type" content="image/jpeg"> -->
    <meta name="author" content="Administrator">
  </Head>

  <section class="postingan">
    <div style="margin: 5em 0; min-height: 100vh">
      <div class="container">
        <div class="card">
          <div class="card-body" style="padding: 5rem">
            <h1 class="mt-0 fw-bold" v-text="title"></h1>
            <p class="text-muted">
              <span v-text="new Date(created_at).toLocaleString()"></span>
              <span class="px-2">-</span>
              <span v-text="'Administrator'"></span>
            </p>
            <div v-if="islogged && status_postingan != 'PUBLISED'">
              <div class="d-inline-block statusp">
                <span>{{ status_postingan }}</span>
              </div>
            </div>
            <hr class="mb-4" />
            <div class="row gap-4">
              <div class="col-md-8">
                <div v-html="content" style="font-size: 1.125em;"></div>
              </div>
              <div class="col border-start">
                <p class="mb-3">
                  <span class="fw-bold">TERBARU</span>
                </p>

                <ul>
                  <li v-for="(r, i) in terbaru" :key="i" >
                    <div>
                      <a :href="`/postingan/${r.slug}`" v-text="r.title"></a>
                    </div>
                    <span v-text="new Date(r.created_at).toLocaleDateString()"></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import layout from '@/layout/Portal'
import { Head } from '@inertiajs/inertia-vue3'
export default {
  layout,
  components: { Head },
  props: {
    desc: Object,
    host: String,
    url: String,
    terbaru: Array,

    islogged: Boolean,
    status_postingan: String,
    title: String,
    created_at: String,
    content: String,
  },
}
</script>

<style lang="scss" scoped>
:deep(h1), :deep(h2), :deep(h3), :deep(h4), :deep(h5), :deep(h6) {
  margin-top: 2rem;
}

:deep(p) {
  line-height: 2;
  text-align: justify;
  margin-bottom: 2em;
}

:deep(.wp-block-image) {
  margin-bottom: 2em !important;

  img {
    width: 100%;
  }
}

ul {
  list-style: none;
  padding: 0;
  margin: 0 0 0 1em;
}

ul li {
  padding-bottom: 1em;
}
.statusp {
  rotate: 315deg;
  background: rgb(106 185 255 / 44%);
  padding: 0.5em 6em;
  position: absolute;
  top: 3em;
  left: -3em;
  font-size: 1em;
  font-weight: bold;
}

</style>
